/* eslint-disable no-undef */
import axios from 'axios';
import gt from 'semver/functions/gt';
function getMeta() {
    const options = {
        method: 'get',
        url: `/meta.json?_=${new Date().getTime()}`,
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: 0,
        },
    };
    return axios(options);
}
export async function isMetaVersionGreaterThanPackageVersion() {
    try {
        const result = await getMeta();
        if (result.status !== 200) {
            return true;
        }
        const { version } = result.data;
        return gt(version, PACKAGE_VERSION);
    }
    catch (_a) {
        return true;
    }
}
